import React from "react";
import { Component } from "react";
import { Control, actions } from "react-redux-form";
import store from "../../../store";

export class CustomMultiSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            searchText: '',
            selectedOptions: props.selectedOptions || [],
            displayText: '',
            isOverflowing: false,
            openUpwards: false
        };
        this.multiSelectRef = React.createRef();
        this.inputElement = null;
    }

    componentDidUpdate(prevProps, prevState) {
        const selectedValues = (this.props.selectedOptions || []).map(selectedKey => {
            const matchedOption = this.props.options.find(option => option.Key === selectedKey);
            return matchedOption ? matchedOption.Value : selectedKey;
        });

        if (prevProps.selectedOptions !== this.props.selectedOptions) {
            this.setState({
                selectedOptions: selectedValues || [],
                displayText: (selectedValues || []).join('; ')
            });
        }

        if (prevState.displayText !== this.state.displayText || prevState.isOpen !== this.state.isOpen) {
            this.checkOverflow();
        }
    }

    checkOverflow = () => {
        if (this.inputElement) {
            const isOverflowing = this.inputElement.scrollWidth > this.inputElement.clientWidth;
            this.setState({ isOverflowing });
        }
    };

    toggleDropdown = () => {        
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
            searchText: '',
        }))
    };

    handleOptionClick = (option) => {
        const { onChange, fieldProps, getValue, options } = this.props;

        this.setState((prevState) => {
            const { selectedOptions } = prevState;
            const optionValue = option.Value;
            const optionIndex = selectedOptions.indexOf(optionValue);

            let newSelectedOptions;
            if (optionIndex !== -1) {
                newSelectedOptions = selectedOptions.filter((value) => value !== optionValue);
            } else {
                newSelectedOptions = [...selectedOptions, optionValue];
            }
            newSelectedOptions.sort((a, b) => a.localeCompare(b));
            const valueSelected = getValue
                ? newSelectedOptions
                : newSelectedOptions.map((selectedOptionValue) => {
                    const selectedOption = options.find((opt) => opt.Value === selectedOptionValue);
                    return selectedOption ? selectedOption.Key : null;
                }).filter((key) => key !== null);

            store.dispatch(actions.change(fieldProps, valueSelected));

            if (typeof onChange === 'function') {
                onChange(newSelectedOptions);
            }

            return {
                selectedOptions: newSelectedOptions,
                displayText: newSelectedOptions.join('; ')
            };
        });
    };

    handleSelectAllClick = () => {
        this.setState((prevState, props) => {
            const allSelected = prevState.selectedOptions.length === props.options.length;
            let newSelectedOptions = [];
    
            if (!allSelected) {
                newSelectedOptions = props.options.map(option => option.Value);
                newSelectedOptions.sort((a, b) => a.localeCompare(b));
            }

            const valueSelected = props.getValue
                ? newSelectedOptions
                : newSelectedOptions.map((selectedOptionValue) => {
                    const selectedOption = props.options.find((opt) => opt.Value === selectedOptionValue);
                    return selectedOption ? selectedOption.Key : null;
                }).filter((key) => key !== null);
    
            store.dispatch(actions.change(props.fieldProps, valueSelected));
    
            if (typeof props.onChange === 'function') {
                props.onChange(newSelectedOptions);
            }
    
            return {
                selectedOptions: newSelectedOptions,
                displayText: newSelectedOptions.join('; ')
            };
        });
    };
    
    isNumericString = (str) => {
        if(str === "") return true;
        return /^\d*\.?\d+$/.test(str); // Returns true if the string consists of digits only
    }

    handleSearchChange = (event) => {
        const { isNumeric = false, maxLength = Infinity } = this.props;
        const val = event.target.value;
        if (val.length > maxLength) return;
        if (isNumeric && !this.isNumericString(val)) return
    
        this.setState({ searchText: val });
    };

    handleFocus = () => {       
        this.setState({ isOpen: true });   
        this.setState((prevState) => {
            const rect = this.multiSelectRef.current.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const spaceBelow = viewportHeight - rect.bottom;
            const spaceAbove = rect.top;
    
            return {               
                openUpwards: spaceBelow < 200 && spaceAbove > spaceBelow, // Check if there's more space above
            };
        });   
    };

    handleBlur = (e) => {
        if (this.multiSelectRef.current && this.multiSelectRef.current.contains(e.relatedTarget) || e.target.classList.contains("custom-select-input")) {
            return;
        }
        this.setState((prevState) => ({
            isOpen: false,
            displayText: prevState.selectedOptions.sort((a, b) => a.localeCompare(b)).join('; ')
        }));  
    };

    filterOptions = () => {
        const { options } = this.props;
        const { searchText } = this.state;

        let filteredOptions = [...options];

        if (searchText) {
            filteredOptions = options.filter((option) =>
                option.Value.toLowerCase().includes(searchText.toLowerCase())
            );
        }

        return filteredOptions.sort((a, b) => {
            const getNumericValue = str => parseFloat(str) || Number.MAX_VALUE;
            return getNumericValue(a.Value) - getNumericValue(b.Value);
        });
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (e) => {
        if (this.multiSelectRef.current && !this.multiSelectRef.current.contains(e.target)) {
            this.setState({ isOpen: false, searchText: '' });
        }  
    };

    render() {
        const { isOpen, selectedOptions, searchText, displayText, isOverflowing,openUpwards } = this.state;
        const { label, placeholder, requiredField, isDisabled, options, fieldProps } = this.props;
        const filteredOptions = this.filterOptions();
        const allSelected = selectedOptions.length === options.length;

        return (
            <div className="multi-select__container" >
                {isOverflowing && (
                    <div className="custom-tool-tip__container">
                        {displayText}
                    </div>
                )}
                <div ref={this.multiSelectRef} className={`custom-select-wrapper multi-select-dropdown 
                        ${isOpen ? 'border-blue' : ''} ${requiredField ? 'required' : ''} ${isDisabled ? 'disabled' : ''}
                        ${openUpwards ? 'open-upwards' : 'open-downwards'}`}>
                    <div className="dropdown-header">
                        <div className="custom-select-label">{label}</div>
                        <Control.text
                            model={fieldProps}
                            className="custom-select-input form-select"
                            value={isOpen ? searchText : displayText}
                            onChange={(e) => this.handleSearchChange(e)}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                            placeholder={placeholder}
                            disabled={isDisabled}
                            getRef={el => this.inputElement = el}
                            autoComplete="off"
                        />
                    </div>
                    {(isOpen && !isDisabled) && (
                        <div className="custom-select-options">
                            {
                                filteredOptions.length > 0 &&
                                <div
                                    className={`dropdown-option ${allSelected ? 'selected' : ''}`}
                                    onMouseDown={this.handleSelectAllClick}
                                >
                                    <input
                                        type="checkbox"
                                        className="checkbox__selection"
                                        checked={allSelected}
                                        readOnly
                                    />
                                    Select All
                                </div>
                            }

                            {filteredOptions.map((option) => (
                                <div
                                    key={option.Key}
                                    className={`dropdown-option ${selectedOptions.includes(option.Value) ? 'selected' : ''}`}
                                    onMouseDown={() => this.handleOptionClick(option)}
                                >
                                    <input
                                        type="checkbox"
                                        className="checkbox__selection"
                                        checked={selectedOptions.includes(option.Key) || selectedOptions.includes(option.Value)}
                                        readOnly
                                    />
                                    {option.Value}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
